import { api, API_ENDPOINTS } from '../apis/constants';

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  author: string;
  publishedAt: string;
  tags: string[];
  slug?: string;
  images?: string[];
}

export interface ArticleListResponse {
  articles: Article[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    total_pages: number;
  };
}

export interface ArticleQueryParams {
  page?: number;
  limit?: number;
  search?: string;
}

class ArticleService {
  async getPublicArticles(params: ArticleQueryParams = {}): Promise<ArticleListResponse> {
    const { page = 1, limit = 12, search } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());
    
    if (search) {
      queryParams.append('search', search);
    }

    const queryString = queryParams.toString();
    const response = await api.get(`${API_ENDPOINTS.ARTICLES.PUBLIC}?${queryString}`);
    return response.data;
  }

  async getArticleById(articleId: string): Promise<Article> {
    const response = await api.get(`${API_ENDPOINTS.ARTICLES.DETAIL}/${articleId}`);
    return response.data;
  }
}

export const articleService = new ArticleService();
export default articleService;
